export enum PositionScopeEnum {
  ALL = 'ALL',
  SELECTED = 'SELECTED',
}
